<div class="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-100">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <svg
      class="mx-auto h-10 w-auto text-blue-700"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <h2 class="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
      Forgot password
    </h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
    <div class="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
      <form action="#" class="space-y-6" method="POST">
        <div class="flex flex-col gap-1">
          <p-float-label>
            <label class="text-sm font-medium" for="email">
              {{ 'auth.login.email' | translate }}
            </label>
            <input class="w-full" id="email" pInputText type="email" />
          </p-float-label>
        </div>

        <div class="flex flex-col gap-1">
          <p-float-label>
            <label class="text-sm font-medium" for="password">
              {{ 'auth.login.password' | translate }}
            </label>
            <input class="w-full" id="password" pInputText type="password" />
          </p-float-label>
        </div>

        <div class="flex items-center justify-end">
          <div class="text-sm/6">
            <a class="font-semibold text-indigo-600 hover:text-indigo-500" href="#">
              Return login?
            </a>
          </div>
        </div>

        <div>
          <button
            class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
